/** Browser path prefix for the SPA (trust.qa.darwinbox.io/trust). */
export const APP_BASE = "/trust"

/** API prefix on the same host. */
export const API_BASE = "/trustapi"

export function appPath(path = "/") {
    const suffix = path.startsWith("/") ? path : `/${path}`
    return suffix === "/" ? `${APP_BASE}/` : `${APP_BASE}${suffix}`
}

export function apiPath(path = "") {
    const suffix = path.startsWith("/") ? path : `/${path}`
    return `${API_BASE}${suffix}`
}
